import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ContactCards } from "@/components/shop/Brand";
import { FaqList } from "@/components/shop/HomeSections";
import { ProductCard } from "@/components/shop/ProductCard";
import { Pager, totalOf } from "@/components/shop/Pager";
import { api } from "@/lib/api";
import { COMPANY } from "@/lib/constants";

const Head = ({ eyebrow, title, text, testid }) => (
  <div>
    <p className="font-display text-sm uppercase tracking-[0.2em] text-amber-600">{eyebrow}</p>
    <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl" data-testid={testid}>{title}</h1>
    {text && <p className="mt-4 max-w-2xl text-stone-600">{text}</p>}
  </div>
);

export function SupportPage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 150);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <div className="mx-auto max-w-[1100px] px-4 py-8 sm:px-6 sm:py-14" data-testid="support-page">
      <Head eyebrow="Assistenza" title="Come possiamo aiutarti?" testid="support-title"
        text="Qui trovi le risposte alle domande più frequenti e i contatti diretti del nostro staff. Per un ordine indica sempre il numero (es. CS-123456)." />
      <nav className="mt-6 flex flex-wrap gap-2 text-sm" aria-label="Sezioni assistenza">
        <a href="#faq" className="rounded-full border-2 border-black px-4 py-1.5 font-semibold hover:bg-amber-100" data-testid="support-jump-faq">Domande frequenti</a>
        <a href="#contatti" className="rounded-full border-2 border-black px-4 py-1.5 font-semibold hover:bg-amber-100" data-testid="support-jump-contacts">Contatti</a>
      </nav>
      <section id="faq" className="mt-12 scroll-mt-28" data-testid="support-faq">
        <h2 className="font-display text-2xl font-bold sm:text-3xl">Domande frequenti</h2>
        <div className="mt-6"><FaqList prefix="faq-page" triggerClass="" /></div>
      </section>
      <section id="contatti" className="mt-16 scroll-mt-28" data-testid="support-contacts">
        <h2 className="font-display text-2xl font-bold sm:text-3xl">Non hai trovato la risposta? Scrivici</h2>
        <div className="mt-6"><ContactCards /></div>
        <div className="mt-6 rounded-2xl border-2 border-black bg-white p-6 shadow-[4px_4px_0_#000]" data-testid="company-info">
          <div data-no-translate data-testid="company-legal">
            <p className="font-display text-xl">{COMPANY.name}</p>
            <p className="mt-1 text-sm text-stone-700">Sede: {COMPANY.address}</p>
            <p className="text-sm text-stone-700">Partita IVA: <span className="font-mono">{COMPANY.vat}</span></p>
          </div>
        </div>
      </section>
    </div>
  );
}

export function CollectionPage() {
  const [items, setItems] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  useEffect(() => { api.get("/products", { params: { featured: true, limit: 24, page } }).then((r) => { setItems(r.data); setTotal(totalOf(r)); }); }, [page]);
  return (
    <div className="mx-auto max-w-[1440px] px-4 py-8 sm:px-6 sm:py-14 lg:px-12" data-testid="collection-page">
      <Head eyebrow="In vetrina" title="Pezzi da collezione" testid="collection-title"
        text="Le carte e i prodotti più rari e ricercati che abbiamo selezionato per i collezionisti." />
      <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4" data-testid="featured-grid">
        {items === null && <p className="col-span-full text-stone-500">Caricamento...</p>}
        {items?.length === 0 && <p className="col-span-full text-stone-500" data-testid="collection-empty">Al momento non ci sono pezzi in vetrina. <Link to="/catalogo" className="text-amber-600 underline">Sfoglia il catalogo</Link></p>}
        {items?.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
      </div>
      {items && <Pager page={page} total={total} size={24} onPage={setPage} testid="collection-pager" />}
    </div>
  );
}
